import api from "@/services/api";
/****************
 * Fields
 ****************/

export default {
  getFields(collectionId) {
    if (collectionId) {
      return api.get(`/api/v1/editor/fields?collection_id=${collectionId}`);
    } else {
      return api.get("/api/v1/editor/fields");
    }
  },

  getField(id) {
    return api.get(`/api/v1/editor/field?id=${id}`);
  },

  createFields(data) {
    return api.post(`/api/v1/editor/fields`, data);
  },

  updateField(data) {
    return api.put(`/api/v1/editor/field`, data);
  },

  deleteField(id) {
    return api.delete(`/api/v1/editor/field?id=${id}`);
  }
};
